import { Box, Card, CardContent, IconButton, List, ListItem, ListItemText, Stack, Typography } from '@mui/material'
import { Delete as DeleteIcon } from '@mui/icons-material'
import { IPayment } from '@typings'
import { formatValueToCurrency } from 'src/utilities/helpers/formatCentToAmount.helper'
import { PAYMENT_METHOD_LABELS, PAYMENT_LABELS } from 'src/constants/payment.constants'
import dayjs from 'dayjs'
import 'dayjs/locale/nl'

interface PaymentListProps {
  payments: IPayment[]
  onDelete?: (paymentId: number) => void
  loading?: boolean
}

export const PaymentList = ({ payments, onDelete, loading }: PaymentListProps) => {
  if (loading) {
    return (
      <Card>
        <CardContent>
          <Typography variant="body2">Laden...</Typography>
        </CardContent>
      </Card>
    )
  }

  if (!payments || payments.length === 0) {
    return (
      <Card>
        <CardContent>
          <Typography
            variant="body2"
            color="text.secondary"
            align="center">
            {PAYMENT_LABELS.NO_PAYMENTS}
          </Typography>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardContent>
        <Typography
          variant="h6"
          gutterBottom>
          {PAYMENT_LABELS.PAYMENT_HISTORY}
        </Typography>
        <List disablePadding>
          {payments.map((payment, index) => (
            <ListItem
              key={payment.id}
              sx={{
                px: 0,
                borderBottom: index < payments.length - 1 ? 1 : 0,
                borderColor: 'divider',
              }}
              secondaryAction={
                onDelete && (
                  <IconButton
                    edge="end"
                    aria-label="delete"
                    size="small"
                    onClick={() => onDelete(payment.id)}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                )
              }>
              <ListItemText
                primary={
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ pr: onDelete ? 6 : 0 }}>
                    <Typography
                      variant="body2"
                      fontWeight={600}>
                      {formatValueToCurrency(payment.amount)}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary">
                      {dayjs(payment.payment_date).locale('nl').format('D MMM YYYY')}
                    </Typography>
                  </Stack>
                }
                secondary={
                  <Box sx={{ mt: 0.5 }}>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      display="block">
                      {PAYMENT_METHOD_LABELS[payment.payment_method]}
                    </Typography>
                    {payment.reference && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        display="block">
                        Ref: {payment.reference}
                      </Typography>
                    )}
                    {payment.notes && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        display="block"
                        sx={{ fontStyle: 'italic' }}>
                        {payment.notes}
                      </Typography>
                    )}
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  )
}
